(function () {
    'use strict';
  
    var CONFIG = {
      propertyPrefix: '_gh_',
      verifyTimeoutMs: 8000,
      pendingMaxAgeMs: 3 * 60 * 1000,
      retryOnFailure: true,
      redirectAfterRetry: '/cart',
      notifyUrl: ''
    };
  
    var STORAGE_KEY = 'btaCapture.pending';
    var XPROPS_PREFIX = '__btaXprops_';
    var POLL_MS = 1500;
    var BOOKING_KEYS = ['_date_iso8601', '_start_iso8601', '_finish_iso8601', 'Date', 'Time', 'Start', 'Finish'];
  
    var lastAddResponse = null;
    var wrapped = [];
    var verifying = false;
  
    function getPending() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var pending = JSON.parse(raw);
        if (Date.now() - pending.submittedAt > CONFIG.pendingMaxAgeMs) {
          clearPending();
          return null;
        }
        return pending;
      } catch (e) {
        return null;
      }
    }
  
    function setPending(pending) {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending)); } catch (e) {}
    }
  
    function clearPending() {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
  
    function isCartAddUrl(url) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
    }
  
    function bookingSummary(item) {
      var p = item.properties || {};
      return [p.Date, p.Time, p.Start, p.Finish, p.Location, p.Resource].filter(Boolean).join(' ');
    }
  
    function variantName(id) {
      try {
        var variants = window.ShopifyAnalytics.meta.product.variants;
        var match = variants.filter(function (v) { return String(v.id) === String(id); })[0];
        return match ? match.name : '';
      } catch (e) {
        return '';
      }
    }
  
    function stampItems(items, source) {
      items.forEach(function (item) {
        item.properties = item.properties || {};
        item.properties[CONFIG.propertyPrefix + 'capture'] = [
          variantName(item.id) || ('variant ' + item.id),
          bookingSummary(item),
          new Date().toISOString()
        ].filter(Boolean).join(' | ');
        item.properties[CONFIG.propertyPrefix + 'source'] = source;
      });
    }
  
    function cartRequest(path, body) {
      return fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    }
  
    function sameBooking(item, line) {
      if (String(line.variant_id) !== String(item.id)) return false;
      var want = item.properties || {};
      var have = line.properties || {};
      var keys = BOOKING_KEYS.filter(function (k) { return want[k] !== undefined && want[k] !== null && want[k] !== ''; });
      if (!keys.length) return true;
      return keys.every(function (k) { return String(have[k]) === String(want[k]); });
    }
  
    function onWidgetSubmit(payload) {
      if (!payload || !Array.isArray(payload.items) || !payload.items.length) return;
      stampItems(payload.items, 'widget');
      setPending({
        submittedAt: Date.now(),
        page: location.pathname,
        reservationId: payload.id || null,
        cartToken: payload.cart_token || null,
        retried: false,
        items: payload.items.map(function (item) {
          return { id: item.id, quantity: item.quantity, properties: Object.assign({}, item.properties) };
        })
      });
      lastAddResponse = null;
    }
  
    function wrapXprops() {
      var keys;
      try { keys = Object.keys(window); } catch (e) { return; }
  
      keys.forEach(function (key) {
        if (key.indexOf(XPROPS_PREFIX) !== 0) return;
        var props = window[key];
        if (!props || typeof props !== 'object' || wrapped.indexOf(props) !== -1) return;
        if (typeof props.onSubmit !== 'function') return;
  
        var originalSubmit = props.onSubmit;
        var wrappedSubmit = function (payload) {
          try { onWidgetSubmit(payload); } catch (e) {}
          var result = originalSubmit.apply(this, arguments);
          setTimeout(verifyPending, POLL_MS);
          return result;
        };
  
        try {
          props.onSubmit = wrappedSubmit;
        } catch (e) {
          return;
        }
        wrapped.push(props);
      });
    }
  
    function recordAddResponse(ok, status, bodyText) {
      var pending = getPending();
      if (!pending || pending.retried) return;
      var body = {};
      try { body = JSON.parse(bodyText); } catch (e) {}
      lastAddResponse = { ok: ok, status: status, body: body };
      if (!ok) verifyPending();
    }
  
    function observeCartAdds() {
      var nativeFetch = window.fetch;
      if (nativeFetch) {
        window.fetch = function (input) {
          var url = typeof input === 'string' ? input : (input && input.url);
          var result = nativeFetch.apply(this, arguments);
          if (isCartAddUrl(url) && getPending()) {
            result.then(function (res) {
              res.clone().text().then(function (text) { recordAddResponse(res.ok, res.status, text); });
            }, function (err) {
              recordAddResponse(false, 0, String(err));
            });
          }
          return result;
        };
      }
  
      var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
      if (proto) {
        var nativeOpen = proto.open;
        var nativeSend = proto.send;
        proto.open = function (method, url) {
          this.__btaCaptureUrl = url;
          return nativeOpen.apply(this, arguments);
        };
        proto.send = function () {
          if (isCartAddUrl(this.__btaCaptureUrl) && getPending()) {
            var xhr = this;
            xhr.addEventListener('loadend', function () {
              recordAddResponse(xhr.status >= 200 && xhr.status < 300, xhr.status, xhr.responseText);
            });
          }
          return nativeSend.apply(this, arguments);
        };
      }
    }
  
    function lineLanded(pending) {
      return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var lines = cart.items || [];
          return pending.items.every(function (item) {
            return lines.some(function (line) { return sameBooking(item, line); });
          });
        })
        .catch(function () { return false; });
    }
  
    function describeResponse(r) {
      var body = (r && r.body) || {};
      return body.description || body.message || ('HTTP ' + (r ? r.status : '?'));
    }
  
    function verifyPending() {
      var pending = getPending();
      if (!pending || verifying) return;
      verifying = true;
  
      lineLanded(pending).then(function (landed) {
        verifying = false;
        if (landed) {
          clearPending();
          return;
        }
        var addFailed = lastAddResponse && !lastAddResponse.ok;
        var timedOut = Date.now() - pending.submittedAt > CONFIG.verifyTimeoutMs;
        if (addFailed || timedOut) {
          handleFailure(pending, addFailed ? describeResponse(lastAddResponse) : 'add-to-cart never landed');
        } else {
          setTimeout(verifyPending, POLL_MS);
        }
      });
    }
  
    function handleFailure(pending, reason) {
      if (CONFIG.retryOnFailure && !pending.retried) {
        pending.retried = true;
        setPending(pending);
  
        var items = pending.items.map(function (item) {
          var props = Object.assign({}, item.properties);
          props[CONFIG.propertyPrefix + 'source'] = 'theme-retry';
          return { id: item.id, quantity: item.quantity, properties: props };
        });
  
        cartRequest('/cart/add.js', { items: items })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              if (res.ok) {
                notify('retry-succeeded', pending, reason);
                clearPending();
                if (location.pathname === CONFIG.redirectAfterRetry) location.reload();
                else location.assign(CONFIG.redirectAfterRetry);
                return;
              }
              finalFailure(pending, reason + ' / retry: ' + (body.description || body.message || res.status));
            });
          })
          .catch(function (err) {
            finalFailure(pending, reason + ' / retry: ' + err.message);
          });
        return;
      }
  
      finalFailure(pending, reason);
    }
  
    function finalFailure(pending, reason) {
      clearPending();
      console.warn('[bta-capture] booking could not be added:', reason, pending);
      recordOnCart(pending, reason);
      notify('failed', pending, reason);
    }
  
    function recordOnCart(pending, reason) {
      var note = pending.items.map(function (item) {
        return item.properties[CONFIG.propertyPrefix + 'capture'] || ('variant ' + item.id);
      }).join(' || ') + ' | ' + reason;
      var attributes = {};
      attributes[CONFIG.propertyPrefix + 'failed_booking'] = note.slice(0, 500);
      cartRequest('/cart/update.js', { attributes: attributes }).catch(function () {});
    }
  
    function notify(event, pending, reason) {
      if (!CONFIG.notifyUrl) return;
      var data = JSON.stringify({
        event: event,
        reason: reason,
        shop: location.hostname,
        page: pending.page,
        submittedAt: new Date(pending.submittedAt).toISOString(),
        reservationId: pending.reservationId,
        cartToken: pending.cartToken,
        items: pending.items
      });
      fetch(CONFIG.notifyUrl, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain' },
        body: data
      }).catch(function () {});
    }
  
    function watchForWidgets() {
      wrapXprops();
  
      var observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType === 1 && (node.tagName === 'IFRAME' || (node.querySelector && node.querySelector('iframe')))) {
              wrapXprops();
              return;
            }
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
  
      var ticks = 0;
      var timer = setInterval(function () {
        wrapXprops();
        if (++ticks >= 150) clearInterval(timer);
      }, 2000);
    }
  
    observeCartAdds();
    watchForWidgets();
    if (getPending()) setTimeout(verifyPending, 500);
  })();